import { BasePageDto } from "../../types/dto/base-page-dto";

export const initPage: BasePageDto<any> = {
  contents: [],
  currentPage: 1,
  totalElements: 0,
  totalPage: 1,
  isFirst: true,
  isLast: true,
};
